import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, NoPreloading } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { DashboardPromoteMusicComponent } from './components/dashboard/dashboard-promote-music/dashboard-promote-music.component';
import { UploadVideosComponent } from './components/upload-videos/upload-videos.component';
import { DistributionGuideComponent } from './components/distribution-guide/distribution-guide.component';
import { MasterclassComponent } from './components/masterclass/masterclass.component';

const routes: Routes = [
    {
        path: '',
        
        loadChildren: () => import(/* webpackChunkName: "home-page" */'./home/home.module').then(m => m.HomeModule),
        data: {
            'metaTitle': 'Get Discovered - Distribute, Promote and Monetise Music | Songdew.com',
            'metaDescription': 'Songdew is the most wholistic music platform for artists to distribute, promote and tap revenue genrating opportunities. Music fans could listen to GREAT MUSIC.',
            'metaKeywords': 'new mp3 song download, latest songs, listen to music, listen songs online, latest songs download, free (with download), free (with listen), new latest song, artist album, best new artist, trending songs, latest audio songs',
            'metaImg': '',
            'page': 'home', 'navigation_type': 'home'
        }
    },

    {
        path: '404.html',
        loadChildren: () => import(/* webpackChunkName: "404" */'./not-found/not-found.module').then(m => m.NotFoundModule)
    },
   {
       path:'pro-perks',
       component: MasterclassComponent
    },

    // {
    //     path: 'what-is-new',
    //     loadChildren: () => import('./what-is-new/what-is-new.module').then(m => m.WhatIsNewModule),
    //     data: {
    //         'metaTitle': 'Listen Songs Online, Watch and Download Video Songs | Songdew.com',
    //         'metaDescription': 'Listen and download  mp3 songs ,hindi songs , english songs, punjabi songs for free. New album songs,new song 2018 mp3 download. Also watch latest music video and hd video song  on Songdew',
    //         'metaKeywords': '',
    //         'metaImg': ''
    //     },
    //     canActivate: [AuthGuard]
    // },

    {
        path: 'albums',
        redirectTo: 'songs',
        pathMatch: 'full'
    },

    {
        path: 'songs',
        loadChildren: () => import(/* webpackChunkName: "songs" */'./songs/songs.module').then(m => m.SongsModule),
        data: { 'type': '', 'page': 'songs-listing' }
    },
    {
        path: 'albums',
        loadChildren: () => import(/* webpackChunkName: "albums" */'./songs/songs.module').then(m => m.SongsModule),
        data: { 'type': 'album', 'page': 'songs-listing' }
    },
{
        path: 'distribution-guide',
        component: DistributionGuideComponent
    },

    {
        path: 'faq',
        loadChildren: () => import(/* webpackChunkName: "faq" */'./faq/faq.module').then(m => m.FaqModule),
        data: { 'type': '', 'page': 'faq-center' }
    },
    {
        path: 'playlists',
        loadChildren: () => import(/* webpackChunkName: "palylist" */'./songs/songs.module').then(m => m.SongsModule),
        data: { 'type': 'playlist', 'page': 'playlists-listing' }
    },

    {
        path: 'video-songs',
        loadChildren: () => import(/* webpackChunkName: "video" */'./videos/videos.module').then(m => m.VideosModule),
        data: { 'page': 'videos-listing' }
    },

    {
        path: 'about',
        loadChildren: () => import(/* webpackChunkName: "about" */'./about/about.module').then(m => m.AboutModule)
    },

    {
        path: 'artist',
        loadChildren: () => import(/* webpackChunkName: "artist" */'./artists/artists.module').then(m => m.ArtistsModule),
        data: {
            'navigation_type': 'artist_pages'
        }
    },

    {
        path: 'songdew-in-campus',
        loadChildren: () => import(/* webpackChunkName: "campus" */'./campus-idol/campus-idol.module').then(m => m.CampusIdolModule),
        data: {
            'navigation_type': 'artist_pages'
        }
    },

    {
        path: 'brands',
        loadChildren: () => import(/* webpackChunkName: "branse" */'./brands/brands.module').then(m => m.BrandsModule),
        data: {
            'navigation_type': 'branding'
        }
    },
    {
        path: 'royalty-splits',
        loadChildren: () => import('./royalty-splits/royalty-splits.module').then(m => m.RoyaltySplitsModule)
    },
    {
        path: 'mydashboard',
        loadChildren: () => import(/* webpackChunkName: "dashboard" */'./dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'promote',
        loadChildren: () => import(/* webpackChunkName: "promote" */'./promote/promote.module').then(m => m.PromoteModule),
        data: {
            'metaTitle': 'Distribute or Release and Promote your Music | Songdew.com',
            'metaDescription': 'Songdew is the most wholistic music platform for artists to distribute, promote and tap revenue genrating opportunities. Music fans could listen to GREAT MUSIC.',
            'metaKeywords': 'distribute music, release song,promote music,generate revenue,free download',
            'metaImg': '',
            'page': 'home',
            'navigation_type': 'promote'
        }

    },

    {
        path: 'growth-tools',
        loadChildren: () => import(/* webpackChunkName: "growth-tools" */'./growth-tools/growth-tools.module').then(m => m.GrowthToolsModule),
        data: {
            'metaTitle': 'Growth Tools - Promote your Music | Songdew.com',
            'metaDescription': 'Put your music in front of the right audience with Songdew Growth Tools - managed ad campaigns for artists.',
            'metaKeywords': 'youtube ads, growth tools, promote music, ad campaign',
            'metaImg': '',
            'page': 'growth-tools',
            'navigation_type': 'promote'
        }
    },

    {
        path: 'library',
        loadChildren: () => import(/* webpackChunkName: "library" */'./library/library.module').then(m => m.LibraryModule),
        data: { 'page': 'library' }
    },

    {
        path: 'my-feed',
        redirectTo: ''
        // loadChildren: () => import('./feed/feed.module').then(m => m.FeedModule),
        // canActivate: [AuthGuard]
    },

    {
        path: 'embed',
        loadChildren: () => import(/* webpackChunkName: "emb" */'./embed/embed.module').then(m => m.EmbedModule)
    },

    {
        path: 'programme-format',
        loadChildren: () => import(/* webpackChunkName: "programme" */'./programme/programme.module').then(m => m.ProgrammeModule)
    },

    {
        path: 'login-full',
        loadChildren: () => import(/* webpackChunkName: "loginfull" */'./login/login.module').then(m => m.LoginModule),
        data: {
            'footer': false,
            'header': false,
            'metaTitle': 'Login on Songdew',
            'metaDescription': 'Make an account on Songdew.com',
            'metaKeywords': ''
        }
    },

    {
        path: 'register',
        loadChildren: () => import(/* webpackChunkName: "register" */'./register/register.module').then(m => m.RegisterModule),
        data: {
            'footer': false,
            'header': false,
            'metaTitle': 'Register on Songdew',
            'metaDescription': 'Make an account on Songdew.com',
            'metaKeywords': ''
        }
    },
    {
        path: 'on-boarding',
        loadChildren: () => import(/* webpackChunkName: "onboard" */'./on-boarding/on-boarding.module').then(m => m.OnBoardingModule),
        data: {
            'footer': false
        }
    },
    {
        path: 'subscription',
        loadChildren: () => import(/* webpackChunkName: "subs" */'./subscription/subscription.module').then(m => m.SubscriptionModule),


    },
    {
        path: 'opportunity',
        loadChildren: () => import(/* webpackChunkName: "opp-list" */'./opportunity/opportunity.module').then(m => m.OpportunityModule),
        data: { 'page': 'opportunity-listing' }
    },
    {
        path: 'opportunities',
        loadChildren: () => import(/* webpackChunkName: "opp-liting" */'./opportunities/opportunities.module').then(m => m.OpportunitiesModule),
        data: { 'type': '', 'page': 'opportunity-listing' }
    },

    {
        path: 'upload',
        loadChildren: () => import(/* webpackChunkName: "uploads" */'./upload/upload.module').then(m => m.UploadModule)
    },
    {
        path: 'upload-tracks',
        redirectTo: 'upload/tracks'
    },
    {
        path: 'upload-video',
        redirectTo: 'upload/videos'
    },


    {
        path: 'song-upload',
        redirectTo: 'upload/song'
    },
    {
        path: 'album-upload',
        redirectTo: 'upload/album'
    },

    {
        path: 'video-upload',
        redirectTo: 'upload/video'
    },

    {
        path: 'edit',
        loadChildren: () => import(/* webpackChunkName: "edit-pro" */'./edit/edit.module').then(m => m.EditModule),
        data: { 'page': 'my-profile' }
    },


    {
        path: 'edit-playlist',
        redirectTo: 'edit/playlist',
        data: { 'page': 'my-profile' }
    },

    {
        path: 'artists',
        loadChildren: () => import(/* webpackChunkName: "artist-listing" */'./artists-listing/artists-listing.module').then(m => m.ArtistsListingModule),
        data: {
            'type': '',
            'metaTitle': 'Discover Singers,Bands,Musicians -Music,Gigs, Production | Songdew.com',
            'metaDescription': 'Discover music of outstanding singers, bands and musicians,Contact them for live events, gigs and production work | Songdew.com',
            'metaKeywords': '',
            'page': 'artists-listing'
        }
    },

    {
        path: 'notifications',
        loadChildren: () => import(/* webpackChunkName: "notification" */'./notifications/notifications.module').then(m => m.NotificationsModule)
    },
    {
        path: 'songdew-tv',
        loadChildren: () => import(/* webpackChunkName: "sdtv" */'./tv/tv.module').then(m => m.TvModule)
    },

    {
        path: 'distribute',
        loadChildren: () => import(/* webpackChunkName: "distribution" */'./distribution/distribution.module').then(m => m.DistributionModule),
        data: {
            'type': '',
            'metaTitle': 'Distribute your music | Songdew.com',
            'metaDescription': 'Distribute your music  | Songdew.com',
            'metaKeywords': '',
            'page': 'distribute'
        }
    },
    {
        path: 'distribution',
        redirectTo: 'distribute'
    },
    {
        path: 'blog',
        loadChildren: () => import(/* webpackChunkName: "blogs-list" */'./blog/blog.module').then(m => m.BlogModule),
        data: { 'page': 'blogs-listing' }
    },
    {
        path: 'blogs',
        loadChildren: () => import(/* webpackChunkName: "blog-listing" */'./blogs/blogs.module').then(m => m.BlogsModule),
        data: { 'page': 'blogs-listing' }
    },

    {
        path: 'my-orders',
        loadChildren: () => import(/* webpackChunkName: "orders" */'./orders/orders.module').then(m => m.OrdersModule)
    },

    {
        path: 'messaging',
        loadChildren: () => import(/* webpackChunkName: "messaging" */'./messaging/messaging.module').then(m => m.MessagingModule)
    },

    {
        path: 'search',
        loadChildren: () => import(/* webpackChunkName: "search" */'./search/search.module').then(m => m.SearchModule)
    },

    {
        path: 'settings',
        loadChildren: () => import(/* webpackChunkName: "setting" */'./settings/settings.module').then(m => m.SettingsModule),
        data: { 'page': 'my-profile' }
    },

    {
        path: 'forgot-password',
        loadChildren: () => import(/* webpackChunkName: "forgot" */'./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
    },
    {
        path: 'reset-password/:slug1/:slug2',
        loadChildren: () => import(/* webpackChunkName: "reset" */'./change-password/change-password.module').then(m => m.ChangePasswordModule)
    },
    {
        path: 'verify-email/:slug1/:slug2',
        loadChildren: () => import(/* webpackChunkName: "v-email" */'./email-link-verify/email-link-verify.module').then(m => m.EmailLinkVerifyModule)
    },

    {
        path: 'song-embed/:slug',
        redirectTo: 'embed/song/:slug',
        data: { 'embed': true, 'type': 'song' }
    },
    {
        path: 'album-embed/:slug',
        redirectTo: 'embed/album/:slug',
        data: { 'embed': true, 'type': 'album' }
    },
    {
        path: 'playlist-embed/:slug',
        redirectTo: 'embed/playlist/:slug',
        data: { 'embed': true, 'type': 'playlist' }
    },
    {
        path: 'sdlink',
        loadChildren: () => import(/* webpackChunkName: "presave" */'./sdLink/sd-link.module').then(m => m.SDLinkModule),
        data: {
            'footer': false,
            'header': false,

        }
    },
    {
        path: 'video-embed/:slug',
        redirectTo: 'embed/video/:slug',
        data: { 'embed': true }
    },
    {
        path: 'revenuereports',
        loadChildren: () => import(/* webpackChunkName: "rv-report" */'./revenue-reports/revenue-reports.module').then(m => m.RevenueReportsModule),
        canActivate: [AuthGuard],
    },
    {
        path: '404',
        loadChildren: () => import(/* webpackChunkName: "4041" */'./not-found/not-found.module').then(m => m.NotFoundModule)
    },

    {
        path: ':slug',
        loadChildren: () => import(/* webpackChunkName: "epk" */'./profile/profile.module').then(m => m.ProfileModule),
        data: {
            'page': 'user-profile',
            'navigation_type': 'user-profile',
            'metaTitle': 'My e-Press Kit - Songdew.com',
            
        }
        //pathMatch: 'full'

    },

    {
        path: '**',
        loadChildren: () => import(/* webpackChunkName: "def" */'./not-found/not-found.module').then(m => m.NotFoundModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(
        routes,
        {
    preloadingStrategy: NoPreloading
}
    )],
    exports: [RouterModule]
})
export class AppRoutingModule { }
